import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './TopQuantity.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import MarketFandO from "../../MarketFandO";
import { Vortex } from 'react-loader-spinner'

function TopQuantity() {
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState('all');
    // const [groupValueFUT, setGroupValueFUT] = useState('all');
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "all") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/-/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/opt/-/-/-/VOL/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else if (groupValue === "allfut") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/nifty/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/fut/-/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        // else if (groupValue === "all") {
        //     const getUrl = BaseURL + "HighLowOpenIntrest";
        //     // alert(`${getUrl}/MR/-/fut/-/-/-/DOI/-/-`)
        //     fetch(`${getUrl}/MW/-/OPT/-/S/-/-/-/-`)
        //         .then((response) => response.json())
        //         .then((data) => {
        //             getData = data.data;
        //             setData(getData);
        //             //console.log(getData, "getData")
        //         })
        //         .catch((error) => {
        //         });
        // }
        else if (groupValue === "NIFTYfut") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/fut/nifty/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "NIFTYopt") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/opt/nifty/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "BANKNIFTYfut") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)BANKNIFTY
            fetch(`${getUrl}/MR/fut/Banknifty/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "Bankniftyopt") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/opt/Banknifty/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "cnxitfut") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)BANKNIFTY
            fetch(`${getUrl}/MR/fut/cnxit/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "Cnxitopt") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)BANKNIFTY
            fetch(`${getUrl}/MR/opt/cnxit/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else if (groupValue === "futstk") {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)BANKNIFTY
            fetch(`${getUrl}/MR/futstk/-/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")futstk
                })
                .catch((error) => {
                });
        }
        else {
            const getUrl = BaseURL + "Mostactivecontracts";
            // alert(`${getUrl}/MR/-/fut/cnxit/-/-/DOI/-/-`)
            fetch(`${getUrl}/MR/optstk/-/-/-/VOL/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")futstk
                })
                .catch((error) => {
                });
        }



        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Top Quantity</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='TopTrade-loser-sc'>
                            <div className='TopTrade-header'>
                                <h2><span>Top Quantity</span></h2>
                            </div>

                            <MarketFandO optionValue="Top Quantity" optionDrop="Derivative" />
                            <div className='TopTrade-right'>
                                <div className='TopTrade-inner-select'>
                                    <select onChange={(event) => { setGroupValue(event.target.value); }}>

                                        <option value="all" selected>All Options</option>
                                        <option value="allfut">All Futures</option>
                                        <option value="NIFTYfut">Nifty Futures</option>
                                        <option value="NIFTYopt">Nifty Options</option>
                                        <option value="BANKNIFTYfut">Banknifty Futures</option>
                                        <option value="Bankniftyopt">Banknifty Options</option>
                                        <option value="cnxitfut">Cnxit Futures</option>
                                        <option value="Cnxitopt">Cnxit Options</option>
                                        <option value="futstk">Stock Futures</option>
                                        <option value="">Stock Options</option>
                                    </select>
                                </div>

                            </div>

                            <div className='TopTrade-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left' >Instrument Type</th>
                                            <th className='text-left' >Symbol</th>
                                            <th className='text-right'>Expiry Date</th>
                                            {/* <th className='text-right'>Option Type</th> */}
                                            {/* <th className='text-right'>Strike Price(&#8377;)</th> */}
                                            <th className='text-right'>Last Price(&#8377;)</th>
                                            <th className='text-right'>Today's Change(&#8377;)</th>
                                            <th className='text-right'>Open Interest</th>
                                            <th className='text-right'>Volume (Nos.)</th>
                                            <th className='text-right'>Value(&#8377; in CR)</th>
                                        </tr>



                                    </thead>
                                    <tbody>




                                        {currentTableData && currentTableData.map(
                                            ({ InstName, Symbol, ExpDate, LTP, FaOchg, OI, Qty, Value }) => (
                                                <tr>
                                                    <td className="text-left"> {InstName}</td>
                                                    <td className="text-left"> {Symbol}</td>

                                                    <td className="text-right"> {format(parseISO(ExpDate), 'dd-MMM-yyyy')}</td>
                                                    {/* <td className="text-right"> {OptType}</td>
                                                    <td className="text-right"> {(StrikePrice != null) ? StrikePrice.toFixed(2) : 0}</td> */}
                                                    <td className="text-right"> {(LTP != null) ? LTP.toFixed(2) : 0}</td>
                                                    <td><p className={FaOchg.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {FaOchg != null ? FaOchg.toFixed(2) : 0} </p></td>
                                                    {/* <td className="text-right"> {(FaOchg != null) ? FaOchg.toFixed(2) : 0}</td> */}
                                                    <td className="text-right"> {(OI != null) ? OI.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(Qty != null) ? Qty.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(Value != null) ? Value.toFixed(2) : 0}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default TopQuantity;
